export const searchContextSuggestionsDictionary: Partial<Record<ContextSuggestions, string>> = {
  label: "labels",
};

export enum ContextSuggestions {
  Name = "name",
  Label = "label",
  Folder = "folder",
  Space = "space",
}
